import React from 'react'
import * as R from 'ramda'
import Surveys from '.'
import useAxios from 'hooks/useAxios'

export default function SurveyContainer({ isCreate, userLoading, canCreateSurvey }) {
  const { data: activeSurvey, loading: loadingActiveSurvey } = useAxios({
    url: `survey/views/?limit=50&order_by=desc&status=active&exclude_closed=true`,
    method: 'get',
  })

  const loading = userLoading || loadingActiveSurvey

  return (
    <Surveys
      isCreate={isCreate}
      loading={loading}
      activeSurveys={R.prop('results', activeSurvey)}
      totalSurvey={R.prop('count', activeSurvey)}
      canCreateSurvey={canCreateSurvey}
    />
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/Admin/Surveys/container.js